import { Typography } from "@suraasa/placebo-ui"
import { Link } from "react-router-dom"
import { getPlatformURL } from "utils/helpers"

import blogsIcon from "./assets/blogs.webp"
import masterclassIcon from "./assets/masterclass.webp"
import micSpeakingIcon from "./assets/mic-speaking.webp"
import profileIcon from "./assets/profile.webp"
import sendMailIcon from "./assets/send-mail.webp"
import videoIcon from "./assets/video.webp"

type ResourceType = {
  icon: string
  title: string
  description: string
  link: string
}

const resourcesArray: ResourceType[] = [
  {
    icon: masterclassIcon,
    title: "Masterclasses",
    description: "Learn from international experts in 1-hour CPD sessions",
    link: getPlatformURL("suraasa", "/masterclasses/all"),
  },
  {
    icon: blogsIcon,
    title: "Blogs",
    description: "Explore latest trends & teaching insights",
    link: getPlatformURL("suraasa", "/blog"),
  },
  {
    icon: videoIcon,
    title: "Videos",
    description: "Discover bite-sized insights and career growth tips",
    link: "https://www.youtube.com/@SuraasaTeach",
  },
  {
    icon: profileIcon,
    title: "Admission Webinar",
    description: "Receive expert guidance on Suraasa programs",
    link: getPlatformURL("suraasa", "/admissions-webinars"),
  },
  {
    icon: micSpeakingIcon,
    title: "Podcasts",
    description: "Hear what school leaders expect from teachers",
    link: "https://anchor.fm/suraasa",
  },
  {
    icon: sendMailIcon,
    title: "Newsletter",
    description: "Get actionable teaching tips in your inbox",
    link: getPlatformURL("suraasa", "/newsletter"),
  },
]

const ExploreResources = () => {
  return (
    <div className="mb-6">
      <Typography variant="title3">Explore Resources</Typography>
      <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3">
        {resourcesArray.map(resource => (
          <ExploreResourceCard key={resource.title} {...resource} />
        ))}
      </div>
    </div>
  )
}

function ExploreResourceCard({ icon, title, description, link }: ResourceType) {
  return (
    <Link to={link} target="_blank">
      <div className="flex h-full flex-col rounded-xl bg-onSurface-50 p-2 outline outline-1 outline-onSurface-200 transition-all duration-100 ease-in hover:outline-[3px]">
        <div className="mb-3 w-fit rounded-lg bg-[#E7EFF6] p-1">
          <img src={icon} alt="blogs icon" height={20} width={20} />
        </div>
        <div className="mt-auto">
          <Typography variant="subtitle2" className="mb-0.5 text-onSurface-800">
            {title}
          </Typography>
          <Typography
            variant="smallBody"
            className="max-w-[200px] text-muted md:max-w-[250px]"
          >
            {description}
          </Typography>
        </div>
      </div>
    </Link>
  )
}
export default ExploreResources
